module.exports = __webpack_public_path__ + "media/images/crayons-1d6b95034a2cd4b398de8c9f348e8759.jpg";